var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnlink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 7,
    height: 7,
    viewBox: "-0.45 -0.45 7 7",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "a39snqn8oa",
    d: "M3.655 4.875c.057.057.057.148 0 .204l-.535.535c-.71.71-1.865.71-2.575 0-.71-.71-.71-1.866 0-2.576l.535-.535c.056-.056.147-.056.203 0l.475.475c.056.056.056.147 0 .203l-.536.535c-.336.337-.336.884 0 1.22.337.337.884.337 1.22 0l.536-.535c.056-.056.147-.056.203 0l.474.474zm-.677-3.117c.056.056.147.056.203 0l.535-.536c.337-.336.884-.336 1.22 0 .337.337.337.884 0 1.22l-.535.536c-.056.056-.056.147 0 .203l.474.474c.057.057.148.057.204 0l.535-.535c.71-.71.71-1.865 0-2.575-.71-.71-1.865-.71-2.576 0l-.535.535c-.056.056-.056.147 0 .203l.475.475zM5.79 6.062l.271-.27c.113-.113.113-.295 0-.407L.774.096C.662-.016.48-.016.367.096l-.27.271c-.113.113-.113.295 0 .407l5.288 5.288c.112.113.294.113.406 0z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnlink);
export default __webpack_public_path__ + "static/media/unlink.62f8ba0562b49f95a9d4fd90b7fab3d7.svg";
export { ForwardRef as ReactComponent };